import { render, staticRenderFns } from "./Manage2FA.vue?vue&type=template&id=17be4c21&"
import script from "./Manage2FA.vue?vue&type=script&lang=js&"
export * from "./Manage2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports